var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 266.6 83.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a5a6aa;}.cls-1,.cls-2,.cls-3,.cls-4{fill-rule:evenodd;}.cls-2{fill:#007cc4;}.cls-3,.cls-5{fill:#00659c;}.cls-4,.cls-6{fill:#00b9e4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.45,29.57v-21A8.56,8.56,0,0,1,53.94,0h21a8.64,8.64,0,0,1,8.58,8.57v21a8.57,8.57,0,0,1-8.58,8.49h-21a8.65,8.65,0,0,1-5.08-1.66,15.06,15.06,0,0,1,5.8-4.13,5.48,5.48,0,0,0,2.3.47H72a6.18,6.18,0,0,0,6.11-6.19v-15A6.17,6.17,0,0,0,72,5.44H57a6.17,6.17,0,0,0-6.19,6.11v15a4.86,4.86,0,0,0,.48,2.22,14.84,14.84,0,0,1-4.45,5.4,8.35,8.35,0,0,1-1.35-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.21,33.22a25.51,25.51,0,0,1,14.52,4.6A40.16,40.16,0,0,1,31,39.73,19.57,19.57,0,1,0,43.94,64.19a19.78,19.78,0,0,0,.87-5.72,20.21,20.21,0,0,0-1-6.27,34.85,34.85,0,0,1,1.59-9,25.29,25.29,0,1,1-20.19-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M25.36,41.32c8.26,0,25.33-2.7,28-16.12V12.89a5,5,0,0,1,5-4.92H70.54a5,5,0,0,1,5,4.92V25.2a5,5,0,0,1-5,5H58.31C42.67,33.62,42.2,49.34,42.2,58.2A16.87,16.87,0,1,1,25.36,41.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45.45,29.57v-21A8.56,8.56,0,0,1,53.94,0h21a8.64,8.64,0,0,1,8.58,8.57v21a8.57,8.57,0,0,1-8.58,8.49h-21a8.65,8.65,0,0,1-5.08-1.66,15.06,15.06,0,0,1,5.8-4.13,5.48,5.48,0,0,0,2.3.47H72a6.18,6.18,0,0,0,6.11-6.19v-15A6.17,6.17,0,0,0,72,5.44H57a6.17,6.17,0,0,0-6.19,6.11v15a4.86,4.86,0,0,0,.48,2.22,14.84,14.84,0,0,1-4.45,5.4,8.35,8.35,0,0,1-1.35-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.21,33.22a25.51,25.51,0,0,1,14.52,4.6A40.16,40.16,0,0,1,31,39.73,19.57,19.57,0,1,0,43.94,64.19a19.78,19.78,0,0,0,.87-5.72,20.21,20.21,0,0,0-1-6.27,34.85,34.85,0,0,1,1.59-9,25.29,25.29,0,1,1-20.19-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.36,41.32c8.26,0,25.33-2.7,28-16.12V12.89A5,5,0,0,1,58.43,8a5.14,5.14,0,0,1,.78.07H69.49a5,5,0,0,1,6,3.8,5.2,5.2,0,0,1,0,2.29c0,3.23,0,6.28,0,9.52a5,5,0,0,1-3.26,6.28,5.23,5.23,0,0,1-1.52.23H58.31C42.67,33.58,42.2,49.3,42.2,58.16A16.87,16.87,0,1,1,25.36,41.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.75,66.19c-1.28,4.5-4.77,8.55-12.65,8.55-9,0-13.54-6.26-13.54-13.41s5-13.48,13.83-13.48c7.77,0,11.59,4.29,12.42,8.58H76.2c-.69-1.83-2.28-4.24-6.87-4.24-5.14,0-7.95,3.88-7.95,8.94s2.65,9.3,8,9.3c4,0,5.72-1.62,6.83-4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M113.23,61.21c0,7.19-4.82,13.53-14,13.53-8.62,0-13.67-6-13.67-13.51,0-7.12,5.3-13.38,13.91-13.38C108.26,47.85,113.23,54.14,113.23,61.21Zm-21.85-.07c0,5.07,2.73,9.24,8.14,9.24s7.88-4.5,7.88-9.1c0-4.79-2.55-9.06-8.12-9.06C94,52.22,91.38,56.48,91.38,61.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M118.92,74.2V48.4h6.55c6.83,10.21,11.26,16.1,12.83,19h.07c-.24-2.89-.21-7.5-.21-11.73V48.35h5.08v25.8h-6.15c-2.83-4.22-11.61-17.35-13.23-20.31h-.08c.21,3.22.21,6.89.21,11.46v8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M150.6,74.2V48.4h6.54C164,58.61,168.41,64.5,170,67.4H170c-.24-2.89-.21-7.5-.21-11.73V48.35h5.08v25.8h-6.15c-2.83-4.22-11.61-17.35-13.23-20.31h-.08c.21,3.22.21,6.89.21,11.46v8.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.5,63H187.79v6.74h16.32l-.66,4.47H182.28V48.4h21v4.46h-15.5v5.67h14.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M234,66.19c-1.28,4.5-4.77,8.55-12.65,8.55-9,0-13.54-6.26-13.54-13.41s5-13.48,13.83-13.48c7.77,0,11.59,4.29,12.42,8.58h-5.61c-.69-1.83-2.28-4.24-6.87-4.24-5.14,0-8,3.88-8,8.94s2.65,9.3,8,9.3c4,0,5.72-1.62,6.83-4.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M246.24,52.85H237V48.4H261v4.45h-9.27V74.2h-5.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.16,9.37h5.43L95.33,19.6c.68,2.41,1.14,4.62,1.82,7h.14c.69-2.43,1.18-4.64,1.82-7L101.8,9.37H107l-6.85,22H94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.2,9.37h5.13v22H109.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.69,9.37h6.42c6.94,0,11.42,3.34,11.42,10.89s-4.48,11.08-11.13,11.08h-6.71Zm6.11,18c3.86,0,6.46-1.83,6.46-7.08s-2.6-6.89-6.46-6.89h-1v14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M141.83,9.37H156v4.16h-9.11v4.41h7.75v4.17h-7.75v5.06h9.45v4.17H141.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.86,20.26c0-7.18,4.19-11.3,10.32-11.3s10.32,4.15,10.32,11.3-4.19,11.48-10.32,11.48S159.86,27.43,159.86,20.26Zm15.37,0c0-4.41-1.95-7-5-7s-5.06,2.6-5.06,7,2,7.19,5.06,7.19S175.23,24.66,175.23,20.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.7,20.48c0-7.29,5-11.52,10.73-11.52a9.75,9.75,0,0,1,6.83,2.85L198.56,15a5.82,5.82,0,0,0-4-1.75c-3.12,0-5.58,2.66-5.58,7.06s2.17,7.14,5.49,7.14a6.1,6.1,0,0,0,4.45-2l2.71,3.12a9.53,9.53,0,0,1-7.34,3.22C188.52,31.74,183.7,27.88,183.7,20.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.3,9.37h6.14l7.14,22h-5.44l-3-11.13c-.63-2.2-1.24-4.79-1.84-7.09h-.14c-.55,2.32-1.16,4.89-1.79,7.09l-3,11.13h-5.25Zm-2.43,12.87H217.8V26.1H206.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.77,9.37h5.13v17.8h9v4.17H224.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.83,9.37H248v17.8h9v4.17h-14.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 172.4,
    cy: 40.21,
    rx: 94.2,
    ry: 2.23
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.03143486aa4ef1b2f2dbe98dba5613c1.svg";
export { ForwardRef as ReactComponent };